var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import t from '../../../../lib/translate';
import { logout } from '../../../../reducers/authentication';
var StyledLogoutButton = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  :hover{\n    cursor: pointer;\n  }\n"], ["\n  :hover{\n    cursor: pointer;\n  }\n"])));
var LogoutButton = function () {
    return (_jsx(StyledLogoutButton, { children: _jsx("div", __assign({ className: "logout-button", onClick: function () { return logout(); } }, { children: t('navigation.logout') })) }));
};
export default LogoutButton;
var templateObject_1;
